import { render, staticRenderFns } from "./ModelTableFactor.vue?vue&type=template&id=6d7ef20d&scoped=true&"
import script from "./ModelTableFactor.vue?vue&type=script&lang=ts&"
export * from "./ModelTableFactor.vue?vue&type=script&lang=ts&"
import style0 from "./ModelTableFactor.vue?vue&type=style&index=0&id=6d7ef20d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7ef20d",
  null
  
)

export default component.exports